export default "__VITE_ASSET__DvysCSof__"